import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, ShieldCheck } from 'lucide-react';
import { useAdminAuth } from '@/context/AdminAuth';
import { formatApiError } from '@/lib/adminApi';
import { Logo } from '@/components/Logo';
import { Seo } from '@/components/Seo';
import { ADMIN } from '@/constants/testIds';

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const input = 'w-full rounded-xl border border-white/10 bg-elevated px-4 py-3 text-sm text-white placeholder:text-white/40 focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand';

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-5">
      <Seo title="Admin Login" description="Copy.Click admin console" noindex />
      <div className="grid-bg pointer-events-none absolute inset-0 opacity-30" />
      <div className="pointer-events-none absolute left-1/2 top-1/3 -z-0 h-96 w-96 -translate-x-1/2 rounded-full bg-brand/10 blur-[120px]" />
      <div className="relative w-full max-w-md rounded-2xl border border-white/10 bg-surface/80 p-8 backdrop-blur-xl">
        <div className="flex flex-col items-center text-center">
          <Logo />
          <div className="mt-6 flex h-12 w-12 items-center justify-center rounded-xl bg-brand/10 text-brand">
            <ShieldCheck className="h-6 w-6" />
          </div>
          <h1 className="mt-4 font-display text-2xl font-bold text-white">Admin Console</h1>
          <p className="mt-1 text-sm text-white/50">Sign in to manage Copy.Click</p>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="mb-2 block text-sm text-white/70">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid={ADMIN.loginEmail} className={input} placeholder="owner@copy.click" />
          </div>
          <div>
            <label className="mb-2 block text-sm text-white/70">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid={ADMIN.loginPassword} className={input} placeholder="••••••••" />
          </div>
          {error && <p data-testid={ADMIN.loginError} className="rounded-lg bg-destructive/10 px-4 py-2 text-sm text-destructive">{error}</p>}
          <button type="submit" disabled={loading} data-testid={ADMIN.loginSubmit} className="btn-primary w-full justify-center">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Sign in'}
          </button>
        </form>
        <p className="mt-6 text-center text-xs text-white/30">Protected area · all actions are audited</p>
      </div>
    </div>
  );
}
